<div>
  <div class="add-title">
    <h2 class="primary" i18n="@@Add Service Provider">Add Service Provider</h2>
  </div>
  <div>
    <form [formGroup]="addForm" (change)="formChanged()">
      <mat-grid-list cols="2" [cols]="breakpoint" rowHeight="72px" (window:resize)="onResize($event)">
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field>
              <input matInput placeholder="Service Provider Name" i18n-placeholder="@@Service Provider Name" value={{name}} formControlName="name" required>
              <mat-error *ngIf="addForm.controls.name.hasError('required')" i18n="@@Please enter a service provider name">Please enter a service provider name</mat-error>
              <mat-error *ngIf="addForm.controls.name.hasError('pattern')" i18n="@@Please enter a valid service provider name">Please enter a valid service provider name</mat-error>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <input matInput placeholder="Domain" i18n-placeholder="@@Domain" value={{domain}} formControlName="domain" required>
              <mat-error *ngIf="addForm.controls.domain.hasError('required')" i18n="@@Please enter a domain">Please enter a domain</mat-error>
              <mat-error *ngIf="addForm.controls.domain.hasError('email')"  i18n="@@Please enter a valid domain">Please enter a valid domain</mat-error>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-select  placeholder="Organization" i18n-placeholder="@@Organization" formControlName="org_ID" required>
                <mat-option *ngFor="let organization of organizations" [value]="organization.ID">{{organization.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="addForm.invalid" (click)="onAdd()" i18n="@@Add Service Provider">Add Service Provider</button>
      </div>
    </form>
  </div>
</div>
